import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router";
import Header from "../core/common/header";
import ThemeSettings from "../core/common/theme-settings";
import { useEffect, useState } from "react";
import Sidebar from "../core/common/sidebar";
import HorizontalSidebar from "../core/common/horizontal-sidebar";
import TwoColumnSidebar from "../core/common/two-column";
import StackedSidebar from "../core/common/stacked-sidebar";
import DeleteModal from "../core/modals/deleteModal";
import { routePermissionMap } from "../core/data/json/routePermissionMap";
import GlobalBirthdayCelebration from "../core/common/birthday/GlobalBirthdayCelebration";

const Feature = () => {
  const handleDelete = async () => {};
  const [showLoader, setShowLoader] = useState(true);
  const headerCollapse = useSelector(
    (state: any) => state.themeSetting.headerCollapse
  );
  const mobileSidebar = useSelector(
    (state: any) => state.sidebarSlice.mobileSidebar
  );
  const miniSidebar = useSelector(
    (state: any) => state.sidebarSlice.miniSidebar
  );
  const expandMenu = useSelector((state: any) => state.sidebarSlice.expandMenu);
  const dataWidth = useSelector((state: any) => state.themeSetting.dataWidth);
  const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
  const dataLoader = useSelector((state: any) => state.themeSetting.dataLoader);
  const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);
  const dataSidebarAll = useSelector(
    (state: any) => state.themeSetting.dataSidebarAll
  );
  const dataColorAll = useSelector(
    (state: any) => state.themeSetting.dataColorAll
  );
  const dataTopBarColorAll = useSelector(
    (state: any) => state.themeSetting.dataTopBarColorAll
  );
  const dataTopbarAll = useSelector(
    (state: any) => state.themeSetting.dataTopbarAll
  );
  const location = useLocation();

  useEffect(() => {
    if (dataTheme === "dark_data_theme") {
      document.documentElement.setAttribute("data-theme", "darks");
    } else {
      document.documentElement.setAttribute("data-theme", "");
    }
  }, [dataTheme]);
  useEffect(() => {
    if (dataLoader === "enable") {
      // Show the loader when navigating to a new route
      setShowLoader(true);

      // Hide the loader after 2 seconds
      const timeoutId = setTimeout(() => {
        setShowLoader(false);
      }, 2000);

      return () => {
        clearTimeout(timeoutId); // Clear the timeout when component unmounts
      };
    } else {
      setShowLoader(false);
    }
    window.scrollTo(0, 0);
  }, [location.pathname, dataLoader]);

  const user = useSelector((state: any) => state?.user?.user?.userDetails);

  const isAuthenticated = !!localStorage.getItem("token");
  const menuItems = user?.menu_items || [];

  const currentPath = location.pathname.toLowerCase();

  if (!isAuthenticated || !user) return <Navigate to="/login" replace />;

  const requiredPermission = routePermissionMap[currentPath];

  if (requiredPermission && !menuItems.includes(requiredPermission)) {
    console.log("Premission Denied");
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <>
      <style>
        {`
      :root {
        --sidebar--rgb-picr: ${dataSidebarAll};
        --topbar--rgb-picr:${dataTopbarAll};
        --topbarcolor--rgb-picr:${dataTopBarColorAll};
        --primary-rgb-picr:${dataColorAll};
      }
    `}
      </style>
      <div
        className={`
       ${dataLayout === "mini" || dataWidth === "box" ? "mini-sidebar" : ""}
       ${
         dataLayout === "horizontal" ||
         dataLayout === "horizontal-single" ||
         dataLayout === "horizontal-overlay" ||
         dataLayout === "horizontal-box"
           ? "menu-horizontal"
           : ""
       }
      ${miniSidebar && dataLayout !== "mini" ? "mini-sidebar" : ""}
      ${dataWidth === "box" ? "layout-box-mode" : ""} ${
          headerCollapse ? "header-collapse" : ""
        }
     ${
       (expandMenu && miniSidebar) || (expandMenu && dataLayout === "mini")
         ? "expand-menu"
         : ""
     }
      
      `}
      >
        <>
          {showLoader ? (
            <>
              <div
                className={`main-wrapper 
        ${mobileSidebar ? "slide-nav" : ""}`}
              >
                <Header />
                <Sidebar />
                <HorizontalSidebar />
                <TwoColumnSidebar />
                <StackedSidebar />
                <Outlet />

                <DeleteModal
                  modalId="delete_modal"
                  onDelete={handleDelete}
                  title="Delete Item"
                  message="Are you sure you want to delete this item? This action cannot be undone."
                />
                {!location.pathname.includes("layout") && <ThemeSettings />}
              </div>
            </>
          ) : (
            <>
              <div
                className={`main-wrapper 
        ${mobileSidebar ? "slide-nav" : ""}`}
              >
                <Header />
                <Sidebar />
                <HorizontalSidebar />
                <TwoColumnSidebar />
                <StackedSidebar />
                <Outlet />
                <DeleteModal
                  modalId="delete_modal"
                  onDelete={handleDelete}
                  title="Delete Item"
                  message="Are you sure you want to delete this item? This action cannot be undone."
                />
                {!location.pathname.includes("layout") && <ThemeSettings />}
              </div>
            </>
          )}
        </>
        {/* <Loader/> */}

        <div className="sidebar-overlay"></div>
      </div>
      <GlobalBirthdayCelebration />
    </>
  );
};

export default Feature;
